import {
  scrollLock,
  escListener,
  debounce,
  setCookie,
  getCookie,
} from './utils'
import { closeSearch } from './nav-utils'

const searchInputs = document.querySelectorAll('.search-input')
const searchInput = document.querySelectorAll('.search-trigger')
const resultsContainer = document.getElementById('predictive-search')
const searchOverlay = document.querySelector('.search-overlay')
const searchPlaceholder = resultsContainer
  .querySelector('.predictive-search__results-container')
  .cloneNode(true)

const searchInputMobile = document.querySelector('#SearchMobile.search-input')
const searchInputMobileClose = document.querySelector(
  '.predictive-search__mobile-close'
)

let products = []
// product = JSON.parse(getCookie('products'));
if (!products.length) {
  fetch('/products.json?limit=1500')
    .then(function (response) {
      return response.json()
    })
    .then(function (data) {
      products = data.products
      const prod = JSON.stringify(data.products)

      // set cookie
      setCookie('products', `${prod}`, 1)
    })
}

const addToCart = (inputElem) => {
  const mainCart = document.getElementById('main-cart')
  const miniCart = document.getElementById('mini-cart-overlay')
  const miniCartOverlay = document.getElementById('mini-cart')
  const variants = []
  variants.push({
    id: parseInt(inputElem.querySelector('input[name="id"]').value),
    quantity: 1,
  })

  const formData = {
    items: variants,
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json()
    })
    .then(() => {
      // This is the  from our response
      if (mainCart) mainCart.classList.add('added')
      if (miniCart) miniCart.classList.add('open')
      if (miniCartOverlay) miniCartOverlay.classList.add('open')
    })
    .catch((error) => {
      console.error('Error:', error)
    })
}

searchInputs.forEach((el) =>
  el.addEventListener(
    'keydown',
    debounce(function (event) {
      const query = event.target.value
      resultsContainer.classList.add('searching')

      if (query !== '') {
        fetch(
          `/search/suggest.json?q=${query}&resources[type]=product,collection,page,article&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title`
        )
          .then((response) => response.json())
          .then((suggestions) => {
            const productSuggestions = suggestions.resources.results.products
            const collectionSuggestions =
              suggestions.resources.results.collections
            const pageSuggestions = suggestions.resources.results.pages
            const articleSuggestions = suggestions.resources.results.articles
            const initialMenu = resultsContainer.querySelector(
              ".search-sidebar__initial"
            )
            const resultsMenu = resultsContainer.querySelector(
              ".search-sidebar__results"
            )

            resultsContainer.classList.add('open')
            searchOverlay.classList.add('open')

            // write products
            if (productSuggestions.length > 0) {
              resultsContainer.querySelector(
                '.no-results-notice'
              ).style.display = 'none'
              resultsContainer.querySelector('.search-products').style.display =
                'grid'

              let searchProducts = document.createElement('div')
              searchProducts.classList.add('search-products')

              productSuggestions.forEach((product) => {
                //variants
                const variant_id = products.find((prd) => prd.id === product.id)
                  ?.variants[0].id

                const productCard = `
                <div class="c-product-card card">
                  <a href="${product.url}">
                    <figure class="figure--portrait">
                        <img src="${
                          product.featured_image.url
                        };width=400" alt="${product.title}" srcset="${
                  product.featured_image.url
                };width=352 352w" width="400" height="469" class="img-absolute" loading="lazy">
                    </figure>
                    <div class="card__content">
                      <p class="card__title text-lg">
                          ${product.title}
                      </p>
                    </div>
                  </a>

                  <div class="card__bottom">
                  ${
                    product.available && product.tags.indexOf('DTC') > -1
                      ? `
                    <div class="price">
                      <dl><div class="price__regular">
                          <dt>
                            <span class="visually-hidden">Regular price</span>
                          </dt>
                          <dd>
                            <span class="price-item price-item--regular">
                            ${currency}${product.price}
                            </span>
                          </dd>
                        </div>
                        <div class="price__sale" data-price="1650">
                          <dt class="price__compare">
                            <span class="visually-hidden">Regular price</span>
                          </dt>
                          <dd class="price__compare">
                            <s class="price-item price-item--regular"></s>
                          </dd>
                          <dt>
                            <span class="visually-hidden">Sale price</span>
                          </dt>
                          <dd>
                            <span class="price-item price-item--sale">
                            ${currency}${product.price}
                            </span>
                          </dd>
                        </div>
                        <small class=" u-hide">
                          <dt class="visually-hidden">Unit price</dt>
                          <dd>
                            <span></span>
                            <span aria-hidden="true">/</span>
                            <span class="visually-hidden">&nbsp;per&nbsp;</span>
                            <span>
                            </span>
                          </dd>
                        </small>
                      </dl>
                    </div>
                    <form method="post" action="/cart/add" id="product-form-${product.id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                        <input type="hidden" name="form_type" value="product">
                        <input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="${variant_id}">
                        <input type="hidden" id="quantity" min="1" name="quantity" value="1">
                        <button class="button button--card" name="add" type="submit">
                        <svg class="cart-icon" aria-hidden="true" fill="none" focusable="false" height="24" role="presentation" viewBox="0 0 24 24" width="24" xmlns="https://www.w3.org/2000/svg">
                                <path d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6M10 21C10 21.5523 9.55228 22 9 22C8.44772 22 8 21.5523 8 21C8 20.4477 8.44772 20 9 20C9.55228 20 10 20.4477 10 21ZM21 21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21C19 20.4477 19.4477 20 20 20C20.5523 20 21 20.4477 21 21Z" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor"></path>
                              </svg><span>Add <span>to cart</span></span>
                        </button>
                    </form>
                  </div>
                  `
                      : !product.available && product.tags.indexOf('DTC') > -1
                      ? `
                      <a href="${product.url}" class="button--fullwidth button--small-inverted">Learn More</a>
                  `
                      : `
                    <a href="${product.url}" class="button--fullwidth button--small-inverted">Learn More</a>
                  `
                  }

                </div>
                `

                searchProducts.innerHTML += productCard
              })

              resultsContainer
                .querySelector('.search-products')
                .classList.add('search-products__grid')
              resultsContainer.querySelector('.search-products').innerHTML =
                searchProducts.innerHTML

              //add to cart

              const addProduct = document.querySelectorAll(
                '#predictive-search button[type="submit"]'
              )

              if (addProduct.length)
                addProduct.forEach((element) =>
                  element.addEventListener('click', (e) => {
                    // prevent default shopify add to cart functionality
                    e.preventDefault()
                    e.stopPropagation()
                    const inputElem = e.target.closest('.card__bottom')
                    addToCart(inputElem)
                  })
                )
            } else {
              resultsContainer.querySelector(
                '.no-results-notice'
              ).style.display = 'flex'
              resultsContainer.querySelector('.search-products').style.display =
                'none'
            }

            //collections
            let collectionContainer =
              resultsContainer.querySelector('.collection-search')
            if (collectionSuggestions.length > 0) {
              resultsContainer.querySelector(
                '.search-sidebar__collections'
              ).innerHTML = 'Category Matches'
              collectionContainer.innerHTML = ''
              collectionSuggestions.forEach((collection) => {
                let collectionListElement = document.createElement('li')
                let collectionElement = document.createElement('a')
                collectionElement.setAttribute('href', collection.url)
                const divText = collection.title
                let regex = new RegExp('(' + query + ')', 'i')
                let newStr = divText.replace(regex, '<b>$1</b>')
                collectionElement.innerHTML = newStr
                collectionListElement.appendChild(collectionElement)
                collectionContainer.appendChild(collectionListElement)
              })
            } else {
              resultsContainer.querySelector(
                '.search-sidebar__collections'
              ).innerHTML = 'No Category Matches'
              collectionContainer.innerHTML = ''
            }

            //articles
            let articleContainer =
              resultsContainer.querySelector('.article-search')
            if (articleSuggestions.length > 0 && articleContainer) {
              resultsContainer.querySelector(
                '.search-sidebar__articles'
              ).innerHTML = 'Article Matches'
              articleContainer.innerHTML = ''
              articleSuggestions.forEach((article) => {
                let articleListElement = document.createElement('li')
                let articleElement = document.createElement('a')
                articleElement.setAttribute('href', article.url)
                const divText = article.title
                let regex = new RegExp('(' + query + ')', 'i')
                let newStr = divText.replace(regex, '<b>$1</b>')
                articleElement.innerHTML = newStr
                articleListElement.appendChild(articleElement)
                articleContainer.appendChild(articleListElement)
              })
            }
            // else {
            //   resultsContainer.querySelector('.search-sidebar__articles').innerHTML =
            //     'No Article Matches';
            //   articleContainer.innerHTML = '';
            // }

            //searches
            let searchesContainer =
              resultsContainer.querySelector('.searches-search')
            if (productSuggestions.length > 0 && searchesContainer) {
              resultsContainer.querySelector(
                '.search-sidebar__searches'
              ).innerHTML = 'Search Matches'
              searchesContainer.innerHTML = ''
              productSuggestions.forEach((product) => {
                let searchListElement = document.createElement('li')
                let searchElement = document.createElement('a')
                searchElement.setAttribute('href', product.url)
                const divText = product.title
                let regex = new RegExp('(' + query + ')', 'i')
                let newStr = divText.replace(regex, '<b>$1</b>')
                searchElement.innerHTML = newStr
                searchListElement.appendChild(searchElement)
                searchesContainer.appendChild(searchListElement)
              })
            }
            //  else {
            //   resultsContainer.querySelector('.search-sidebar__searches').innerHTML =
            //     'No Search Matches';
            //   searchesContainer.innerHTML = '';
            // }

            //pages
            let pagesContainer = resultsContainer.querySelector('.page-search')
            pageSuggestions.forEach((page) => {
              let pageElement = document.createElement('a')
              pageElement.setAttribute('href', page.url)
              pageElement.innerText = page.title

              pagesContainer?.appendChild(pageElement)
            })

            initialMenu.style.display = "none"
            resultsMenu.style.display = "block"
            resultsContainer.classList.remove('searching')
          })
      } else {
        resultsContainer.querySelector(
          '.predictive-search__results-container'
        ).innerHTML = searchPlaceholder.innerHTML
        initialMenu.style.display = "block"
        resultsMenu.style.display = "none"
        resultsContainer.classList.remove('searching')
      }
    }, 300)
  )
)

// callback function when hitting ESC

const header = document.getElementById('shopify-section-header')

const escCallbackFunction = () => {
  closeSearch()
  //scrollLock(false);
  header.removeEventListener('click', headerClick)
}

//click outside predictive search
searchOverlay.addEventListener('click', () => {
  closeSearch()
  //scrollLock(false);
  escListener(false)
})

searchInputMobileClose.addEventListener('click', () => {
  escCallbackFunction()
})

// click header to close the predictive search
const headerClick = (e) => {
  if (!e.target.classList.contains('search-trigger')) {
    escCallbackFunction()
  }
}

// don't close if clicked on results
resultsContainer.addEventListener('click', (e) => {
  e.stopPropagation()
})

document.querySelectorAll('.search-trigger-mobile').forEach((trigger) => {
  trigger.addEventListener('click', (e) => {
    resultsContainer.classList.add('open')
    document.body.classList.add('active', 'search')
    //scrollLock(true);
    // escListener(true, escCallbackFunction);

    searchOverlay.classList.add('open')
    searchInputMobile.focus()
  })
})

document.querySelectorAll('.search-trigger').forEach((trigger) => {
  trigger.addEventListener('click', (e) => {
    trigger
      .closest('.predictive-search__wrapper')
      .querySelector('#predictive-search')
      .classList.add('open')
    document.body.classList.add('active', 'search')
    //scrollLock(true);
    escListener(true, escCallbackFunction)
    header.addEventListener('click', headerClick)

    searchOverlay.classList.add('open')
    searchInputMobile.focus()
  })
})

searchInputMobile.addEventListener('keyup', (e) => {
  searchInput.value = e.target.value
})

document
  .querySelector('.button.search-input')
  .addEventListener('click', (e) => {
    if (e.target.parentNode.querySelector('#Search').value === '') {
      e.preventDefault()
      e.stopPropagation()
    }
  })

document
  .querySelector('.button.search-input-mobile')
  .addEventListener('click', (e) => {
    if (e.target.parentNode.querySelector('#SearchMobile').value === '') {
      e.preventDefault()
      e.stopPropagation()
    }
  })
